<template>
  <div>
    <medical-plan
      :consent-services="consentServices"
      :annual-notification-services="annualNotificationServices"
      :is-read-only="isReadOnly"
      :services="services"
      :student="student"
      :sign-services="signServices"
      :signature-hub-services="signatureHubServices"
      save-on-back
      show-annual-consent-badge
      @back="back"
    />
  </div>
</template>

<script>
import {
  getPlanTypes,
  get,
  save,
  getHistory,
  getConsent,
  searchConsent,
  saveConsent,
  markSigned,
  saveMechanism,
  saveSignedDocument,
  searchAnnualNotification,
  getAnnualNotificationDocument,
} from '@/services/medical-plan';
import generalService from '@/services/pei/general';
import documentsService from '@/services/documents';
import reportService from '@/services/report';
import {
  getSignatureHubInfo,
  removeSignatureHub,
} from '@/services/signatureHub/api';

import MedicalPlan from 'medical-plan';

export default {
  name: 'MedicalPlanMain',
  components: { MedicalPlan },
  data() {
    return {
      isReadOnly: false,
    };
  },
  computed: {
    services() {
      return Object.freeze({
        getPlanTypes,
        get,
        save,
        getHistory,
        downloadFile: generalService.getDocument,
      });
    },
    consentServices() {
      return Object.freeze({
        get: getConsent,
        search: searchConsent,
        save: saveConsent,
        sign: markSigned,
        saveMechanism,
        saveSignedDocument,
      });
    },
    annualNotificationServices() {
      return Object.freeze({
        search: searchAnnualNotification,
        downloadDocument: getAnnualNotificationDocument,
      });
    },
    signServices() {
      return Object.freeze({
        download: documentsService.downloadFromServer,
        downloadTemplate: reportService.getMedicalPlanConsent,
      });
    },
    signatureHubServices() {
      return Object.freeze({
        get: getSignatureHubInfo,
        remove: removeSignatureHub,
      });
    },
    student() {
      const selected = this.$store.getters['$_student/SelectedStudent'] ?? {};
      return Object.freeze({
        id: Number(selected.studentId),
        name: selected.fullName,
      });
    },
  },
  methods: {
    back() {
      const data = sessionStorage.getItem('MedicalPlanFrom');

      if (data === 'Pei') {
        this.$router.push({
          path: '/pei/detail/',
        });
        return;
      }

      this.$router.push({ name: 'student-menu' });
    },
  },
};
</script>

<style scoped lang="scss"></style>
